import { SubtitleEraseTask } from '../../../types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface SubtitleEraseStatusNoticeProps {
  task?: SubtitleEraseTask;
  t: Translate;
}

export default function SubtitleEraseStatusNotice({ task, t }: SubtitleEraseStatusNoticeProps) {
  if (task?.status === 'running') {
    return (
      <div style={{ marginBottom: '0.4rem', padding: '0.35rem 0.5rem', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.72rem', color: '#d97706' }}>
        <span className="loading-spinner" style={{ width: '12px', height: '12px', borderWidth: '2px' }}></span>
        {t('version.subtitleErasing')}
      </div>
    );
  }

  if (task?.status === 'failed') {
    return (
      <div style={{ marginBottom: '0.4rem', padding: '0.35rem 0.5rem', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '4px', fontSize: '0.72rem', color: '#dc2626' }}>
        {t('version.subtitleEraseFailed', { error: task.errorMsg || '' })}
      </div>
    );
  }

  return null;
}
